import React from 'react'
import useTheme from '@material-ui/core/styles/useTheme'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from '../../contexts/i18n/use'
import { useRest } from '../../contexts/rest/use'

export const TicketFailureModal = ({disablecallback}) => {
  const { actions: { resetTicketFailureStatus } } = useRest();
  const theme = useTheme();
  const classes = useStyles(theme);
  const { actions: {t}} = useTranslation();

  return (
    <Dialog 
      open={true} 
      classes={{paper: classes.modal}}
      >
      <DialogTitle>{ t('queuepage.taketicketfail.title')}</DialogTitle>
      <DialogContent id="queuepage-acceptfailure-dialog-content-id">
        { t('queuepage.taketicketfail.text')}
      </DialogContent>
      <DialogActions className={classes.buttonwrapper}>
      <Button className={classes.confirmbutton} id="queuepage-acceptfailure-confirm-button-id" onClick={() => { disablecallback(false); resetTicketFailureStatus(); }}>
          <Typography id="queuepage-acceptfailure-confirm-button-text-id">
            { t('queuepage.taketicketfail.confirm')}
          </Typography>
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const useStyles = makeStyles({
  modal: theme => ({
    border: '1px solid '+ theme.palette.primary.main,
    alignItems: 'center'
  }),
  buttonwrapper: {
    display: 'flex',
    flexDirection: 'row',
    padding: '1rem 0',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '80%'
  },
  confirmbutton: theme => ({
    backgroundColor: theme.palette.error.main,
    color: theme.palette.button_text.main,
    [theme.breakpoints.up('lg')]: {
      '&:hover': {
        backgroundColor: 'black',
        color: 'white'
      }
    },
    [theme.breakpoints.down('lg')]: {
      '&:hover': {
        backgroundColor: theme.palette.error.main,
        color: theme.palette.button_text.main
      }
    }
  })
})